import axios from "axios";

export const http = axios.create({
  // baseURL: "https://remobidyc.viennatalk.org/api",
  baseURL: "/api",
  headers: {
    "Content-type": "application/json",
  },
});
